import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button
} from "@mui/material"


const ProjectSubmitAdmin = ({ rowData, mainProps, setErrorMessage }) => {



  return (
    <Box>
      <Button
        variant="contained"
        color="primary"
        size="small"
        disabled={rowData.row.isOk}
        onClick={async () => {
            const { onSubmitGasProjectByAdmin } = mainProps
            if(window.confirm("بعد از تایید مجری میتواند نقشه را برای شرکت گاز ارسال نماید مطمئن هستید؟")){
                await onSubmitGasProjectByAdmin(rowData.row.id)
            }
           
        }}
      >
        تایید
      </Button>
    </Box>
  )
}

export default ProjectSubmitAdmin
